import { convertObjToQueryString } from "../../utils/helpers";

export const getUserNutritionAssessmentResponseList = (
  data: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/v1/getNutritionAssessmentResponseList`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getAllAssessmentQuestionsList = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/v1/getAllQuestions`,
  };
};

export const saveNutritionAssessmentResponse = (
  data: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/v1/saveNutritionAssessmentResponses`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getHealthMetricsOptions = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v1/health-metrics-options`,
  };
};

export const getUserReportsList = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v1/reports-list`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getUserReportDetails = (
  reportId: string | undefined,
  userId: string | undefined
) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v1/report-detail/${reportId}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const updateUserReportDetails = (
  data: { [key: string]: any },
  reportId: string | undefined,
  userId: string | undefined
) => {
  return {
    method: "PUT",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v1/update-report/${reportId}`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const deleteUserHealthMetric = (
  queryObj: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "DELETE",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v1/delete-health-metric/${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getUserHealthMetricsList = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v1/all-health-metrics`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const createUserReport = (
  data: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/v2/upload-report`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getPreSignedUrlForReports = (fileName: any) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_ASSESSMENT_URL}/medical-reports/pre-signed-url?bucketName=${process.env.REACT_APP_S3_BUCKET}&objectKey=${fileName}`,
  };
};
